import { render } from "./template.vue?vue&type=template&id=0409a5c2&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=0409a5c2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__